<template>
  <div class="features">
    <v-container class="text-center">
      <v-row>
        <v-col cols="4" sm="4" md="4" lg="4">
          <div
            class="parent d-flex align-center justify-center flex-column flex-sm-row"
            dir="rtl"
          >
            <svg
              class="ml-5 mb-4 mb-sm-0"
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 512.001 512.001"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M486.509,420.091L380.924,314.505l42.706-15.543c3.641-1.325,5.805-5.073,5.131-8.889l-11.44-64.877l32.939-57.053
			c1.937-3.355,1.186-7.617-1.782-10.107l-50.466-42.345l-11.44-64.878c-0.673-3.815-3.987-6.596-7.862-6.596h-65.88L262.367,1.868
			c-2.969-2.491-7.296-2.491-10.265,0l-50.465,42.346h-65.879c-3.875,0-7.189,2.781-7.862,6.596l-11.44,64.877l-50.467,42.346
			c-2.968,2.49-3.719,6.752-1.782,10.107l32.94,57.053l-11.44,64.877c-0.674,3.816,1.49,7.563,5.131,8.889l40.899,14.885
			L25.492,420.091c-2.197,2.198-2.92,5.474-1.85,8.392c1.069,2.919,3.735,4.951,6.833,5.209l65.527,5.462l5.462,65.526
			c0.258,3.098,2.29,5.764,5.209,6.833c0.896,0.329,1.824,0.488,2.745,0.488c2.081,0,4.123-0.814,5.647-2.338l140.936-140.936
			l140.936,140.936c1.525,1.524,3.566,2.338,5.647,2.338c0.921,0,1.85-0.159,2.745-0.488c2.919-1.069,4.951-3.735,5.208-6.833
			L416,439.155l65.526-5.462c3.098-0.258,5.764-2.29,6.833-5.21C489.429,425.564,488.706,422.29,486.509,420.091z M115.946,486.201
			l-4.593-55.105c-0.324-3.885-3.406-6.969-7.293-7.293l-55.105-4.593l99.338-99.338l4.451,1.62l32.939,57.053
			c1.46,2.529,4.13,3.993,6.916,3.993c0.91,0,1.832-0.156,2.729-0.482l38.927-14.168L115.946,486.201z M263.744,344.904
			l-3.781-1.375c-1.763-0.643-3.697-0.643-5.46,0l-5.6,2.038l-52.741,19.195l-31.043-53.768c-0.939-1.625-2.419-2.868-4.183-3.511
			l-11.96-4.354l-46.381-16.88l10.782-61.141c0.327-1.85-0.009-3.754-0.947-5.38l-31.044-53.768l47.562-39.908
			c1.438-1.206,2.405-2.88,2.729-4.728l10.781-61.142h62.085c1.878,0,3.695-0.661,5.132-1.868l47.56-39.908l47.56,39.908
			c1.438,1.207,3.255,1.868,5.132,1.868h62.086l10.781,61.142c0.326,1.848,1.292,3.523,2.729,4.728l47.561,39.908l-31.043,53.768
			c-0.939,1.625-1.274,3.53-0.948,5.379l10.782,61.141l-48.188,17.539l-10.154,3.696c-1.763,0.643-3.245,1.885-4.183,3.511
			l-31.042,53.768l-54.55-19.854C263.753,344.906,263.748,344.906,263.744,344.904z M407.942,423.804
			c-3.885,0.324-6.969,3.406-7.293,7.293l-4.592,55.105L276.334,366.476l42.806,15.581c0.897,0.327,1.819,0.482,2.729,0.482
			c2.786,0,5.456-1.464,6.916-3.993l32.938-57.053l2.644-0.962l98.68,98.68L407.942,423.804z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M256.002,68.521c-70.141,0-127.204,57.063-127.204,127.204s57.064,127.203,127.204,127.203
			c70.141,0,127.203-57.063,127.203-127.203S326.142,68.521,256.002,68.521z M256.002,306.961
			c-61.336,0-111.237-49.901-111.237-111.237S194.666,84.488,256.002,84.488c61.335,0,111.237,49.901,111.237,111.237
			S317.337,306.961,256.002,306.961z"
                  />
                </g>
              </g>
              <g>
                <g>
                  <path
                    d="M347.882,170.302c-1.069-3.29-4.134-5.517-7.593-5.517h-58.922l-18.207-56.038c-1.069-3.29-4.134-5.517-7.593-5.517
			c-3.458,0-6.524,2.227-7.593,5.517l-18.208,56.038h-58.922c-3.458,0-6.524,2.227-7.593,5.517
			c-1.069,3.289,0.102,6.893,2.901,8.926l47.669,34.633l-18.208,56.039c-1.069,3.289,0.102,6.893,2.901,8.926
			c1.399,1.017,3.045,1.525,4.692,1.525s3.293-0.509,4.692-1.525l47.669-34.632l47.668,34.632c2.798,2.033,6.587,2.033,9.384,0
			c2.798-2.032,3.968-5.636,2.901-8.926l-18.208-56.039l47.669-34.633C347.78,177.195,348.95,173.591,347.882,170.302z
			 M283.235,204.354c-2.798,2.032-3.969,5.636-2.901,8.926l12.407,38.186l-32.483-23.599c-2.798-2.033-6.587-2.033-9.384,0
			l-32.484,23.6l12.407-38.187c1.069-3.289-0.102-6.893-2.901-8.925l-32.482-23.601h40.153c3.458,0,6.524-2.227,7.593-5.517
			l12.407-38.186l12.406,38.186c1.069,3.29,4.134,5.517,7.593,5.517h40.153L283.235,204.354z"
                  />
                </g>
              </g>
            </svg>
            <span>جودة عالية</span>
          </div>
        </v-col>
        <v-col cols="4" sm="4" md="4" lg="4">
          <div
            class="parent d-flex align-center justify-center flex-column flex-sm-row second"
            dir="rtl"
          >
            <svg
              data-name="Layer 1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 128 128"
              class="ml-5 mb-4 mb-sm-0"
            >
              <path
                d="M113.854 66.726H109.6a31.725 31.725 0 0 0-19.8-19.873v-10.32a1.75 1.75 0 0 0-2.182-1.7 14.743 14.743 0 0 0-3.168 1.217c.059-.637.1-1.28.1-1.93A20.551 20.551 0 1 0 47.871 46.9a31.3 31.3 0 0 0-19.83 20.327 7.713 7.713 0 0 0-2.656-2.083c-.805-4.681-4.249-9.957-11.3-9.72a1.75 1.75 0 1 0 .119 3.5 6.908 6.908 0 0 1 7.095 4.6 10.512 10.512 0 0 1 .377 1.079 5.071 5.071 0 0 0-4.353 3.007 4.246 4.246 0 0 0 .752 4.39 4.4 4.4 0 0 0 4.593 1.134c1.513-.43 2.366-1.892 2.717-3.675A8.435 8.435 0 0 1 26.9 72.4a31.832 31.832 0 0 0-.29 4.267 31.3 31.3 0 0 0 8.784 21.8 20.346 20.346 0 0 1 5.593 14.212 1.75 1.75 0 0 0 1.75 1.75h14.371a1.749 1.749 0 0 0 1.75-1.75v-4.558h19.368v4.558a1.749 1.749 0 0 0 1.75 1.75h14.376a1.75 1.75 0 0 0 1.75-1.75 19.193 19.193 0 0 1 5.722-13.589 31.478 31.478 0 0 0 9.06-17.817h2.97a1.751 1.751 0 0 0 1.75-1.75V68.476a1.75 1.75 0 0 0-1.75-1.75zM21.6 69.8a.974.974 0 0 1-.927-.138.732.732 0 0 1-.1-.748 1.728 1.728 0 0 1 1.485-.831A3.5 3.5 0 0 1 21.6 69.8zM64 17.073a17.062 17.062 0 0 1 16.2 22.386v.011a16.942 16.942 0 0 1-9.416 10.292 30.579 30.579 0 0 0-13.559 0 17.1 17.1 0 0 1-4.8-3.106 1.712 1.712 0 0 0-.269-.256A17.061 17.061 0 0 1 64 17.073zm48.1 60.7h-2.77a1.75 1.75 0 0 0-1.742 1.583 27.961 27.961 0 0 1-8.223 17.24 22.755 22.755 0 0 0-6.7 14.333H81.726v-4.563a1.75 1.75 0 0 0-1.75-1.75H58.061c-.242 0-.481-.009-.721-.017l-.172-.006a1.652 1.652 0 0 0-1.276.491 1.748 1.748 0 0 0-.534 1.258v4.582H44.423a23.692 23.692 0 0 0-6.513-14.885 27.939 27.939 0 0 1 12.714-46.306A20.761 20.761 0 0 0 52.71 51.3a15.822 15.822 0 0 0-3.737 2.33 1.75 1.75 0 0 0 2.3 2.643C53.942 53.944 58.821 52.5 64 52.5s10.055 1.443 12.73 3.767a1.75 1.75 0 1 0 2.3-2.643 15.815 15.815 0 0 0-3.736-2.33 20.371 20.371 0 0 0 8.038-10.179 12.364 12.364 0 0 1 2.968-2.082v9.1a1.748 1.748 0 0 0 1.262 1.68 28.149 28.149 0 0 1 19.06 19.14 1.751 1.751 0 0 0 1.683 1.268h3.8z"
              />
              <path
                d="M95.192 61.632a1.75 1.75 0 0 0-1.75 1.75 2.011 2.011 0 1 1-4.021 0 1.75 1.75 0 1 0-3.5 0 5.511 5.511 0 1 0 11.021 0 1.749 1.749 0 0 0-1.75-1.75zM60.993 38.881a1.75 1.75 0 0 0-3.5 0 6.514 6.514 0 0 0 4.758 6.261v1.108a1.75 1.75 0 1 0 3.5 0v-1.108a6.5 6.5 0 0 0 0-12.522v-5.687a3 3 0 0 1 1.258 2.435 1.75 1.75 0 0 0 3.5 0 6.514 6.514 0 0 0-4.758-6.261V22a1.75 1.75 0 1 0-3.5 0v1.108a6.5 6.5 0 0 0 0 12.521v5.688a3 3 0 0 1-1.258-2.436zm6.014 0a3 3 0 0 1-1.256 2.434v-4.869a3 3 0 0 1 1.256 2.435zm-6.014-9.513a3 3 0 0 1 1.256-2.434V31.8a3 3 0 0 1-1.256-2.432z"
              />
            </svg>
            <span>أثمنة مناسبة</span>
          </div>
        </v-col>
        <v-col class="is" cols="4" sm="4" md="4" lg="4">
          <div
            class="parent d-flex align-center justify-center flex-column flex-sm-row"
            dir="rtl"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 64 64"
              class="ml-5 mb-4 mb-sm-0"
            >
              <path
                d="m14 42.63.16-.47a1 1 0 0 0-1.9-.64l-.16.47a1 1 0 0 0 1.9.64z"
              />
              <path
                d="m55.66 53.8-5.49-17.15A10.94 10.94 0 0 0 39.7 29H37v-1.21a10.92 10.92 0 0 0 2.31-1.59A1 1 0 0 0 38 24.72 9 9 0 0 1 23 18v-1.81a6.29 6.29 0 0 0 2 .72c1 .16 13.17.11 13.7 0C41.57 16.61 41 15 41 18a9 9 0 0 1-.87 3.86 1 1 0 0 0 1.8.86 10.87 10.87 0 0 0 .88-2.8A4 4 0 0 0 46 16c0-1.36.1-3.27-2-4.47A10 10 0 0 0 34 1c-3.9 0-5.58-.18-7.87.78a1 1 0 0 0 .78 1.84C28.78 2.83 30 3 34 3a8 8 0 0 1 7.94 7H22.06a7.92 7.92 0 0 1 2-4.3 1 1 0 0 0-1.48-1.34A9.84 9.84 0 0 0 20 11.53c-2.05 1.15-2 3-2 4.47a4 4 0 0 0 3.17 3.91A11 11 0 0 0 27 27.79V29h-2.7a10.94 10.94 0 0 0-10.47 7.65l-.35 1.1a1 1 0 0 0 1.9.6l.35-1.1A9 9 0 0 1 24.3 31h3.12a5 5 0 0 0 9.16 0h3.12a9 9 0 0 1 8.57 6.25l5.49 17.15A5 5 0 0 1 50 60.89V55a6 6 0 0 0-5-5.91V47a1 1 0 0 0-2 0v9H21V37h7v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-5h7v6a1 1 0 0 0 2 0v-7a1 1 0 0 0-1-1H20a1 1 0 0 0-1 1v13.09A6 6 0 0 0 14 55v5.89a5.06 5.06 0 0 1-3.76-6.49l2.59-8.11a1 1 0 0 0-1.9-.6L8.34 53.8A7.06 7.06 0 0 0 15 63c10 0 9.28 0 10-.09a6 6 0 0 0 4.89-4.85c0-.1-.26-.06 4.18-.06a6 6 0 0 0 2 3.51C38.3 63.47 40.18 63 49 63a7.05 7.05 0 0 0 6.66-9.2zM26 15a4 4 0 0 1-3.86-3c21.86 0 19.86-.18 19.58.43C40.45 15.73 38.7 15 26 15zm18 1a2 2 0 0 1-1 1.73c0-4.37-.11-3 .42-4.15A3 3 0 0 1 44 16zm-24-1a2 2 0 0 1 .58-1.42c.53 1.11.42-.24.42 4.15-1.11-.64-1-1.63-1-2.73zm11.5 17a3 3 0 0 1-2.5-3v-.42a11.21 11.21 0 0 0 6 0V29a3 3 0 0 1-3.5 3zm2.5 5v4h-4v-4zM16 61v-6a4 4 0 0 1 3-3.87V57a1 1 0 0 0 1 1h7.86a3.94 3.94 0 0 1-2.16 2.61c-1.13.53-1.12.39-9.7.39zm24 0a4 4 0 0 1-3.86-3H44a1 1 0 0 0 1-1v-5.87A4 4 0 0 1 48 55v6z"
              />
            </svg>
            <span>التوصيل سريع</span>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div style="width: 100%; margin: 0 auto">
      <img
        src="@/assets/teset.jpg"
        alt="Responsive Large Image"
        style="width: 100%; height: auto; display: block"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BookTitleSection",
};
</script>
<style lang="scss">
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");

.parent {
  font-family: "Noto Kufi Arabic", sans-serif;
}
.features {
  span {
    font-weight: bold;
    font-size: 1.5em;
  }
  .second {
    position: relative;
    &::before {
      content: "";
      position: absolute;
      background-color: rgb(172, 172, 172);
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 70%;
    }

    &::after {
      content: "";
      position: absolute;
      background-color: rgb(172, 172, 172);
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 70%;
    }
  }
}
@media (max-width: 531px) {
  .features {
    .second {
      &::before,
      &::after {
        display: none;
      }
    }
  }
}

svg {
  width: 50px;
}
@media (max-width: 600px) {
  svg {
    width: 35px;
  }
  .parent {
    span {
      font-weight: bold;
      font-size: 1em;
    }
  }
}
</style>
